import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormProvider, useForm } from 'react-hook-form';
import { useAppDispatch, RootState } from '@/store';
import BreadcrumbLayout from '@/components/common/CustomLayout/BreadcrumbLayout';
import { ReactComponent as IcYoutube } from '@/assets/icons/ic_youtube.svg'
import { ReactComponent as RiDeleteBin } from '@/assets/icons/ri-delete-bin-6-line.svg'
import { ReactComponent as RiCheckmarkLine } from '@/assets/icons/ri-checkmark-line.svg'
import Input from '@/components/common/Input';
import Button from '@/components/common/Button';
import 'react-datepicker/dist/react-datepicker.css'
import { getVideos, addVideo, deleteVideo } from '@/store/video/action';
import PreviewBanner from './preview_banner';


const renderExistingVideos = (
  existingVideos: Video[],
  deleteExistingVideo: Function
) => (
  existingVideos.map(video => (
    <div className="border border-grey-line-subtle w-fit rounded px-4 py-2 pb-4">
        <div className="flex pb-2">
          <p className="grow text-jsm font-normal text-grey-darkoverflow-hidden">
              {video.title}
          </p>
          <div className="flex-none">
            <Button className="text-red-primary flex items-center p-0 hover:cursor-pointer"
                    variant='tertierry'
                    onClick={() => deleteExistingVideo(video)}>
              <RiDeleteBin/>
            </Button>
          </div>
        </div>
        <PreviewBanner video={video}/>
    </div>
  ))
)

const renderNewVideo = (
  { videoMethod }: any,
  newVideo,
  createNewVideo: Function,
  removeNewVideo: Function
) => {
  const id = newVideo.id !== null ? newVideo.id : ""

  return (
  <FormProvider {...videoMethod}>
      <div className='flex items-center py-2 gap-7 w-80%'
           key={id}>
        <div className="h-full">
          <IcYoutube />
        </div>
        <div className="flex flex-grow-0 gap-7 items-center">
          <Input name='videoTitle'
                 type='text'
                 placeholder='Video Title'
                 {...videoMethod.register(`video.${id}.title`)}
          />
          <Input name='videoSrc'
                 type='text'
                 placeholder='https://www.youtube.com/watch?v=1234abcd'
                 {...videoMethod.register(`video.${id}.src`)}
          />
          <div className="bg-grey-line-subtle h-6 w-1"/>
        </div>
        <Button className="text-red-primary flex items-center p-0 hover:cursor-pointer"
                variant='tertierry'
                onClick={() => {
                  removeNewVideo()
                }}>
          <RiDeleteBin/>
        </Button>
        <Button className="text-green-success flex items-center p-0 hover:cursor-pointer"
                variant='tertierry'
                onClick={() => {
                  createNewVideo(newVideo)
                }}>
          <RiCheckmarkLine/>
        </Button>
      </div>
  </FormProvider>
)}

const Banners = () => {
  const dispatch = useAppDispatch()
  const videoState = useSelector((state: RootState) => state.video.state)
  const [existingVideos, setExistingVideos] = useState([])
  const [newVideo, setNewVideo] = useState([])
  const videoMethod = useForm()

  const deleteExistingVideo = async (video: Video) => {
    await dispatch(deleteVideo(video.id))
    await dispatch(getVideos())
  }

  const createNewVideo = async (video: Video) => {
    const selectedVideos = {...videoMethod.getValues('video')}
    const { title, src } = selectedVideos[video.id]
    const payload = {
      title,
      src,
      description: "",
      thumbnail_image: "",
      is_show: true
    }
    await dispatch(addVideo(payload))
    await dispatch(getVideos())
  }

  const removeNewVideo = async () => {
    setNewVideo(null)
  }


  useEffect(() => {
    (async () => {
      await dispatch(getVideos())
    })()
    setExistingVideos([...videoState])
  }, [])

  useEffect(() => {
    setExistingVideos([...videoState])
  }, [dispatch, getVideos, videoState])

  return (
    <BreadcrumbLayout>
      <div className='flex flex-col w-full gap-8'>
        <div className='flex flex-col p-0'>
          <div className='flex pl-8 pt-8 bg-white rounded-t'>
            <p className='font-bold text-lg'>
              Add Video Banner
            </p>
          </div>
          <div className='flex flex-col gap-2 p-7 bg-white'>
            {renderNewVideo({ videoMethod }, newVideo, createNewVideo, removeNewVideo)}
          </div>
          <div className='flex flex-col gap-2 p-7 bg-white'>
              <p className='font-bold text-lg'>
                Video Banners
              </p>
              <div className='p-4 grid grid-flow-col auto-cols-max gap-4'>
                {renderExistingVideos(existingVideos, deleteExistingVideo)}
              </div>
            </div>
        </div>
      </div>
    </BreadcrumbLayout>
  );
}

export default Banners
